/*
 * AI 填表员 -「文档编辑工具」列表配置(KV `AI_form_filling_edit_tools`)
 *
 * 命中这些工具名的 tool-call 被视为"文档编辑",触发:
 *   - 左侧预览刷新(每个 edit tool output-available 立即刷一次)
 *   - 导出/分享 footer + 状态徽标的挂载
 *   - 编辑态蒙版 / docActionState
 *   - ai_fill 埋点(区别于普通对话 ai_chat_response)
 *
 * KV value 协议(JSON 字符串):
 *   { "tools": ["excel_edit", "word_edit", "excel_batch_fill"] }
 *
 * 缺省 / 解析失败 / tools 非数组 / 去重后为空 → 一律回落 DEFAULT_EDIT_TOOLS。
 * (空数组不当"禁用全部",否则预览永不刷新等于把功能关了;要加工具就往数组里加。)
 *
 * excel_batch_fill = 批量灌表(从数据集一次填多行),跟 excel_edit 一样写 xlsx,
 * 必须纳入默认,否则 batch_fill 后预览不刷新 / 三件套徽标不挂出。
 */

export const DEFAULT_EDIT_TOOLS = [
  'excel_edit',
  'word_edit',
  'excel_batch_fill'
]

/** 解析 KV value 字符串为工具名数组;任何异常都回落默认。 */
export function parseEditTools(raw: string | null | undefined): string[] {
  if (!raw) return [...DEFAULT_EDIT_TOOLS]
  const trimmed = String(raw).trim()
  if (!trimmed) return [...DEFAULT_EDIT_TOOLS]
  try {
    const obj = JSON.parse(trimmed)
    const list = obj && typeof obj === 'object' ? obj.tools : null
    if (!Array.isArray(list)) return [...DEFAULT_EDIT_TOOLS]
    // 工具名大小写敏感,不转小写;只 trim + 去空 + 去重
    const tools = Array.from(
      new Set(list.map((t: unknown) => String(t).trim()).filter(Boolean))
    )
    return tools.length > 0 ? tools : [...DEFAULT_EDIT_TOOLS]
  } catch {
    return [...DEFAULT_EDIT_TOOLS]
  }
}
